import { apiDelete, apiGet, apiPost, apiPostForm, apiPut } from './api';

export function listVessels() {
  return apiGet('/api/vessels');
}

export function addVessel(payload) {
  return apiPost('/api/vessels', payload);
}

export function updateVessel(id, payload) {
  return apiPut(`/api/vessels/${id}`, payload);
}

export function deleteVessels(ids) {
  return apiDelete('/api/vessels', { ids });
}

export function importVessels(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/api/vessels/import', formData);
}

export function verifyImportVessels(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/api/vessels/import/verify', formData);
}
